<div #scrollContainer>
    <div class="panel panel-default">
        <div [ngClass]="" class="panel-body">
            <div class="row">
                <div class="col-md-4" style="text-align:left;">
                    <div class="btn-group">
                        <div
                        class="btn btn-primary"
                        mwlCalendarPreviousView
                        [view]="'week'"
                        [(viewDate)]="viewDate"
                        >
                        Previous
                        </div>
                        <div
                        class="btn btn-outline-secondary"
                        mwlCalendarToday
                        [(viewDate)]="viewDate"
                        >
                        Today
                        </div>
                        <div
                        class="btn btn-primary"
                        mwlCalendarNextView
                        [view]="'week'"
                        [(viewDate)]="viewDate"
                        >
                        Next
                        </div>
                    </div>
                </div>
                <div class="col-md-4" style="text-align:center;">
                    <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                </div>
                <div class="col-md-4" style="text-align:right;">
                    <div class="btn-group">
                        <div
                        class="btn btn-primary"
                        (click)="setView(CalendarView.Month)"
                        [class.active]="view === CalendarView.Month"
                        >
                        Mois
                        </div>
                        <div
                        class="btn btn-primary"
                        (click)="setView(CalendarView.Week)"
                        [class.active]="view === CalendarView.Week"
                        >
                        Semaine
                        </div>
                        <div
                        class="btn btn-primary"
                        (click)="setView(CalendarView.Day)"
                        [class.active]="view === CalendarView.Day"
                        >
                        Jour
                        </div>
                    </div>
                </div>
            </div>
            <br />
            
            <ng-template
                #weekViewHourSegmentTemplate
                let-segment="segment"
                let-locale="locale"
                let-segmentHeight="segmentHeight"
                let-isTimeLabel="isTimeLabel"
            >
                <div
                #segmentElement
                class="cal-hour-segment"
                [style.height.px]="segmentHeight"
                [class.cal-hour-start]="segment.isStart"
                [class.cal-after-hour-start]="!segment.isStart"
                [ngClass]="segment.cssClass"
                (mousedown)="startDragToCreate(segment, $event, segmentElement)"
                >
                <div class="cal-time" *ngIf="isTimeLabel">
                    {{ segment.date | calendarDate:'weekViewHour':locale }}
                </div>
                </div>
            </ng-template>
            
            <div [ngSwitch]="view">
                <mwl-calendar-month-view
                    *ngSwitchCase="CalendarView.Month"
                    [viewDate]="viewDate"
                    [events]="events"
                    [weekStartsOn]="weekStartsOn"
                    (eventTimesChanged)="eventTimesChanged($event)"
                >
                </mwl-calendar-month-view>
                <mwl-calendar-week-view
                    *ngSwitchCase="CalendarView.Week"
                    [viewDate]="viewDate"
                    [events]="events"
                    [hourSegmentTemplate]="weekViewHourSegmentTemplate"
                    [weekStartsOn]="weekStartsOn"
                    (eventTimesChanged)="eventTimesChanged($event)"
                    (eventClicked)="clickedOnEvent($event.event)"
                >
                </mwl-calendar-week-view>
                <mwl-calendar-day-view
                    *ngSwitchCase="CalendarView.Day"
                    [viewDate]="viewDate"
                    [events]="events"
                    (eventTimesChanged)="eventTimesChanged($event)"
                >
                </mwl-calendar-day-view>
            </div>
        </div>
    </div>
</div>